import {modalMoveMeeting} from "./move-to/move"
import Meeting from "../model2/meeting/meeting";
import {modalAddMeetingUser} from "./users/add-user"
import {AddUser_Manager} from "./users/model/manager"
import UserToAdd from "./users/model/add-user"

export default class MeetingModalsManager {

    addUsers(projectId: ID, meetingUsers: ID[], callback?: any) {
        modalAddMeetingUser(projectId, {
            noUsersCreation : true,
            excludedUserIds : meetingUsers,
            callback        : (manager: AddUser_Manager) => {
                const newUsers = _.map(manager.allUsersToAddSelected, (userToAdd: UserToAdd) => {
                    return {
                        userId  : userToAdd.id,
                        role    : userToAdd.meetingRole,
                    }
                })

                return callback?.(newUsers)
            }
        })
    }

    moveToFolder(meeting: Meeting, callback?: {(projectId: ID): void}) {
        return modalMoveMeeting(meeting, {
            callback: callback,
        })

        /*gd.modal.showV4({
            className: 'modal-move',
            component: ModalMoveTo,
            params: {
                meetingId: meetingId,
                companyId: gd.companyId,
                parentProjectId: parentProjectId,
                arrMeetingUsers: arrMeetingUsers,
                mode: ModalMoveTo_Mode.MEETING,
                type: ModalMoveTo_TargetType.FOLDER,
                onMove: callback
            }
        });*/
    }
}